/* eslint-disable sort-keys */
export const DEFAULT_BASIC_IFRAME_MODAL_LAUNCHER_URL_ENTRIES = [
  [
    'DASHBOARD_GETTING_STARTED_ADMIN', {
      _id: 'DASHBOARD_GETTING_STARTED_ADMIN',
      contentItemId: '',
      customParamKeys: [],
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ],
  [
    'DASHBOARD_GETTING_STARTED_STUDENT', {
      _id: 'DASHBOARD_GETTING_STARTED_STUDENT',
      contentItemId: '',
      customParamKeys: [],
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ],
  [
    'DASHBOARD_GETTING_STARTED_TEACHER', {
      _id: 'DASHBOARD_GETTING_STARTED_TEACHER',
      contentItemId: '',
      customParamKeys: [],
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ],
  [
    'FLOATING_HELP_ADMIN', {
      _id: 'FLOATING_HELP_ADMIN',
      contentItemId: '',
      customParamKeys: [],
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ],
  [
    'FLOATING_HELP_STUDENT', {
      _id: 'FLOATING_HELP_STUDENT',
      contentItemId: '',
      customParamKeys: [],
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ],
  [
    'FLOATING_HELP_TEACHER', {
      _id: 'FLOATING_HELP_TEACHER',
      contentItemId: '',
      customParamKeys: [],
      resourceId: '',
      resourceType: '',
      url: ''
    }
  ]
];
